import { FC, PropsWithChildren } from "react";

import styles from "./layout-blocks.module.scss";

const TopHeader: FC<PropsWithChildren> = ({ children }) => (
  <header className={styles.top_header}>
    <span className={styles.filename}>File Name</span>
    <div className={styles.actions}>{children}</div>
  </header>
);

export default TopHeader;
